import { CheckRideScheduleHoldEntity } from "../../../meta-data/app-meta-data.service";

export interface ScheduleHoldResult {
    Success: boolean;
    ErrorMessage: string;
    ResultAction: ScheduleHoldResultAction;
    CheckRideScheduleHold: CheckRideScheduleHoldEntity;
}

export enum ScheduleHoldResultAction {
    error = 'Error',
    holdStarted = 'HoldStarted',
    holdExtended = 'HoldExtended',
    holdExpired = 'HoldExpired',
    holdCancelled = 'HoldCancelled',
    holdFailed = 'HoldFailed',
}